exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#collapsible-widget-wrapper .collapsible-widget-body {\n  /* max-height: 50vh !important; */\n  overflow: auto;\n}\n\n/* width: 50%; */\n\n/* .table-responsive {\n  height: 100%;\n} */\n.blur {\n  filter: blur(10px);\n}\n.search-panel-results {\n  max-height: 100%;\n  overflow: auto;\n  display: block;\n}\n.collapse-btn {\n  position: sticky;\n  top: 0;\n  padding: 20px;\n  z-index: 999;\n}\n.transform-y-2 {\n  transform: translateY(-2px);\n}\n", ""]);

// exports
